export const reducers = {
  setShowMessage(state, { payload: showMessage }) {
    state.showMessage = showMessage;
  },
};
